import { SubassemblyState, 
  SubassemblyDateFilter,
  Subassembly 
} from "./types";
import {ActionTree, Module, MutationTree, GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {getSubassembly, getSubassemblies, saveSubassembly} from "@/services/subassembly";

export const state: SubassemblyState = {
    subassembly: {
      code: "",
      name: "",
      materials: [],
      MX: "",
      NALADI: "",
      NALADISA: "",
      start_date: "",
      end_date: "",
      intermediate_material: false
    },
    date_filter: {
      date: ""
    }
};

const actions: ActionTree<SubassemblyState, RootState> = {
    async GET_SUBASSEMBLIES(_, payload) {
      return await getSubassemblies(payload);
    },
    async GET_SUBASSEMBLY(_, id) {
      return await getSubassembly(id);
    },
    async SAVE_SUBASSEMBLY(_, subassembly) {
      await saveSubassembly(subassembly);
    },
}


const mutations: MutationTree<SubassemblyState> = {
  SET_SUBASSEMBLY_DATE_FILTER(state, date: SubassemblyDateFilter | undefined) {
    state.date_filter = date;
  },
  SET_SUBASSEMBLY(state, subassembly: Subassembly) {
    state.subassembly = subassembly;
  },
  RESET_SUBASSEMBLY(state) {
    state.subassembly = {
      code: "",
      name: "",
      materials: [],
      MX: "",
      NALADI: "",
      NALADISA: "",
      start_date: "",
      end_date: "",
      intermediate_material: false
    }
  },
}

const getters: GetterTree<SubassemblyState, RootState> = {
  SUBASSEMBLY_DATE_FILTER(state): SubassemblyDateFilter | undefined {
    return state.date_filter;
  },
  SUBASSEMBLY(state): Subassembly {
    const {subassembly} = state;
    return {...subassembly};
  }
}

export const subassembly: Module<SubassemblyState, RootState> = {
    state,
    actions,
    mutations,
    getters
}